import { css } from '@emotion/css';
import { colors } from '@/colors';

export const styContainer = ({ block }) => css`
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  padding: 4px;
  border-radius: 8px;
  background-color: ${colors.NEUTRAL_1};
  overflow: hidden;

  ${block &&
  `
    width: 100%;
  `}
`;

export const stySelector = ({ width, left, background }) => css`
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  border-radius: 4px;
  z-index: 0;

  width: ${width || 0}px;
  transform: translate(${left || 0}px);
  background-color: ${background || colors.AJAIB_BLUE_5};
  transition: transform 0.3s ease, width 0.3s ease, color 0.3s ease-in;
`;

export const stySegment = ({ variant }) => css`
  position: relative;
  width: 100%;
  text-align: center;
  z-index: 1;

  span {
    display: block;
    margin: 0;
    padding: 8px 12px;
    color: ${colors.NEUTRAL_7};
    transition: color 0.5s ease;
    cursor: pointer;

    ${variant === 'buy-sell' &&
    `
      font-weight: 700;
    `}
  }

  &.active {
    span {
      color: ${colors.NEUTRAL_0};
    }
  }
`;
